import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalSession {

	initialized:boolean = false;
	socketConnected:boolean = false;
	order:any;
	deviceInfo:any;
	poll:any;

	constructor() { }

	public init(): void {
		this.initialized = true;
	}

	public isInitialized(): boolean {
		return this.initialized;
	}

	public isSocketConnected(): boolean{
		return this.socketConnected;
	}

	public setSocketConnected(status: boolean): void{
		this.socketConnected = status;
	}

	public setOrder(order: any):void {
		this.order = order;
	}

	public getOrder(): any {
		return this.order;
	}

	public setPoll(poll: any):void {
		this.poll = poll;
	}

	public getPoll(): any {
		return this.poll;
	}

	public setDeviceInfo(deviceInfo: any):void {
		this.deviceInfo = deviceInfo;
	}

	public getDeviceInfo(): any {
		return this.deviceInfo;
	}

	

}
